export default __webpack_public_path__ + "static/media/LavieSport.6799e431.jpg";